export default {
    api: {
        storageUrl: `https://westminsterbookings.blob.core.windows.net/`,
        urls: {
            production: `https://westminsterbookings.azurewebsites.net/api/v1/`,
            development: `http://localhost:7071/api/v1/`
        }
    }
}